import { render, staticRenderFns } from "./ProviderOverviewLogStat.vue?vue&type=template&id=19ca768d&scoped=true&"
import script from "./ProviderOverviewLogStat.vue?vue&type=script&lang=js&"
export * from "./ProviderOverviewLogStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ca768d",
  null
  
)

export default component.exports